import {action} from 'mobx';

import apiCollectionGetAllStore from './apiCollectionGetAllStore';
import apiCollectionGetFeedsStore from './apiCollectionGetFeedsStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

const SAFE_COLLECTION_CATEGORIES = ['feed', 'default'];

/**
 * Creates a new collection.
 */
class ApiCollectionCreateStore extends ApiBaseStore {
  /**
   * Creates a new collection using the api.
   *
   * @param {string} collectionName
   * @param {string} collectionCategory
   */
  @action makeRequest(collectionName, collectionCategory) {
    const safeCollectionName = String(collectionName).trim();
    const safeCategory = SAFE_COLLECTION_CATEGORIES.includes(collectionCategory) ? collectionCategory : 'default';

    this.state = STATE_PENDING;
    this.data = null;
    this.error = null;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    const newCollection = {
      name: safeCollectionName,
      category: safeCategory
    };

    serverApi.collectionCreate(newCollection).then(
      action('collectionCreateSuccess', (newCollectionData) => {
        this.state = STATE_FULFILLED;
        this.data = newCollectionData;
        this.error = null;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        const collectionStore = safeCategory === 'feed' ? apiCollectionGetFeedsStore : apiCollectionGetAllStore;
        collectionStore.refresh(true);
      })
    ).catch(
      action('collectionCreateError', (collectionCreateError) => {
        this.state = STATE_FULFILLED;
        this.data = null;
        this.error = collectionCreateError;
      })
    );
  }
}

export default new ApiCollectionCreateStore();
